import { IFilterDates } from '../../interfaces/general/filter-dates.interface';

export abstract class AbstractGeneralService {
  abstract getFromToDate(): Promise<IFilterDates | undefined>;
}
